import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/common/utils/trpc";

export function IfTicketAccess({
	children,
	fallback = null,
}: { children: React.ReactNode; fallback?: React.ReactNode }) {
	const trpc = useTRPC();
	const accessQuery = useQuery(trpc.tickets.hasAccess.queryOptions());

	if (accessQuery.isLoading) return fallback ?? null;
	if (accessQuery.data) return children;
	return fallback ?? null;
}
